import React from 'react';

import styles from './SharingPicture.module.scss';

const SharingPicture = () => {
  return (
    <div className={styles.sharingPictureContainer}>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <p className={styles.heading}>
            Khi công ty vừa tròn sáu tháng, hơn <span className={styles.highlight}>10,000 nhà giao dịch</span> trên toàn thế giới đã tham gia PipFarm, và chúng tôi đã trả cho các nhà giao dịch <span className={styles.highlight}>hơn 600,000 USD lợi nhuận</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SharingPicture;
